import React, { useEffect, useState, useRef } from "react";
import {
  bp_add_meta_data,
  bp_get_machine_by_machine_typ,
  bp_machine_data,
  bp_save_batch_ingredients,
} from "../../../utils/api";
import { toast } from "react-toastify";
import { Input, Select, Button, Descriptions, Avatar } from "antd";
import MainCard from '@/components/MainCard';
import { useDispatch, useSelector } from "react-redux";
import { settab_number } from '@/store/reducers/tabNumber';
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { defaultColors } from '@/themes/antd-theme';

function AddIngredient() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const operation_data = state?.operation_data;

  const dispatch = useDispatch();
  const [machine, set_machine] = useState("");
  const [ingredient, set_ingredient] = useState([]);

  const handle_ingredient = (ingredient_id, e, index) => {
    if (e.target.value === "") {
      let temp = [...ingredient];
      temp.splice(index, 1);
      set_ingredient(temp);
    } else {
      let temp = [...ingredient];
      temp[index] = {
        process_ingredient_id: ingredient_id,
        quantity: e.target.value,
      };
      set_ingredient(temp);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submit_function(ingredient);
  };

  //####################### Handle Api's######################################################
  const [machine_data, setMachineData] = useState([]);
  const get_all_machine = async () => {
    try {
      await bp_get_machine_by_machine_typ(success_machine_list_get, {
        machine_type_id: operation_data?.machine_id,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_machine_list_get = (res) => {
    setMachineData(res?.data?.data);
  };

  useEffect(() => {
    get_all_machine();
  }, [operation_data]);

  const submit_function = async (process_ingredient) => {
    try {
      await bp_save_batch_ingredients(
        {
          process_ingredient: process_ingredient?.filter(Boolean),
          operation_id: operation_data?.operation_id,
          machine_id: machine,
          batch_number: operation_data?.batch_number,
        },
        success_bp_save_batch_ingredients
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_bp_save_batch_ingredients = (res) => {
    if (res.status === "failed") {
      toast.warning(res.message);
    } else {
      resetFunction();
      navigate("/batch");
      toast.success("Metadata added Successfully");
    }
  };

  const resetFunction = () => {
    set_ingredient([]);
    set_machine("");
  };

  const handle_single_add = (index) => {
    let temp = ingredient[index];
    submit_function([temp]);
  };

  return (
    <MainCard darkTitle title="Ingredients" backbutton>
      <form onSubmit={handleSubmit}>
        <Descriptions
          title=""
          bordered
          column={2}
          contentStyle={{
            fontSize: "24px",
          }}
          labelStyle={{
            fontSize: "32px",
            fontWeight: "bold",
          }}
          items={[
            {
              key: "5",
              label: "Instruction",
              children: operation_data?.instruction,
              span: 2,
            },
            {
              key: "1",
              label: "Batch No",
              children: operation_data?.batch_number,
            },
            {
              key: "2",
              label: "Operation",
              children: `${operation_data?.operation_type} - ${operation_data?.operation_number}`,
            },
            {
              key: "3",
              label: "Machine",
              children: (
                <Select
                  value={machine}
                  size="large"
                  placeholder="Select Machine"
                  onChange={(value) => set_machine(value)}
                  style={{
                    width: "100%",
                    fontSize: "24px",
                  }}
                  options={machine_data?.map((item) => ({
                    label: item.machine_name,
                    value: item.machine_id,
                  }))}
                />
              ),
            },
            {
              key: "4",
              label: "Duration",
              children: operation_data?.max_duration,
            },
          ]}
        />

        <div className="my-8 space-y-6">
          {operation_data?.ingredients?.map((item, index) => (
            <div key={index} className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-center">
              <div className="lg:col-span-4">
                <label className="text-2xl font-medium text-center block">
                  {item?.ingredient_name}
                </label>
              </div>
              <div className="lg:col-span-8">
                <div className="flex gap-2 items-center">
                  {item?.ingredient_qty === "" ? (
                    <Input
                      type="number"
                      size="large"
                      value={ingredient[index]?.quantity}
                      onChange={(e) => {
                        handle_ingredient(item?.ingredient_id, e, index);
                      }}
                      suffix={
                        <Avatar
                          shape="square"
                          style={{
                            color: "#000",
                            backgroundColor: "#fff",
                            fontSize: "24px",
                          }}
                        >
                          {`${item?.unit}`}
                        </Avatar>
                      }
                      style={{
                        height: "50px",
                        fontSize: "24px",
                      }}
                    />
                  ) : (
                    <Input
                      type="number"
                      size="large"
                      disabled
                      value={item?.ingredient_qty}
                      suffix={
                        <Avatar
                          shape="square"
                          style={{
                            color: "#000",
                            backgroundColor: "#fff",
                            fontSize: "24px",
                          }}
                        >
                          {`${item?.unit}`}
                        </Avatar>
                      }
                      style={{
                        height: "50px",
                        fontSize: "24px",
                      }}
                    />
                  )}

                  <Button
                    type="primary"
                    size="large"
                    style={{
                      backgroundColor: defaultColors.primary,
                      borderColor: defaultColors.primary,
                      height: "50px",
                      fontSize: "24px",
                      minWidth: "100px",
                    }}
                    onClick={() => {
                      handle_single_add(index);
                    }}
                  >
                    Add
                  </Button>
                </div>
              </div>
            </div>
          ))}

          <div className="flex justify-end items-end gap-2 mt-6">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              style={{
                backgroundColor: defaultColors.primary,
                borderColor: defaultColors.primary,
                height: "50px",
                fontSize: "24px",
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </form>
    </MainCard>
  );
}

export default AddIngredient;
